import React, { Component } from 'react';
import { Button, crudUpdateMany as crudUpdateManyAction } from 'react-admin';
import { connect } from 'react-redux';

class BulkAccountApproval extends Component {
  handleClick = () => {
    const {
      basePath,
      resource,
      selectedIds,
      crudUpdateMany,
    } = this.props;

    crudUpdateMany(resource, selectedIds, {}, basePath);
  };

  render() {
    return (
      <Button label="Approve" onClick={this.handleClick} />
    );
  }
}

export default connect(undefined, { crudUpdateMany: crudUpdateManyAction })(BulkAccountApproval);



// WEBPACK FOOTER //
// ./src/components/NewAccounts/BulkAccountApproval.js